import React, {useRef, useEffect, useCallback, useState } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setFilters, resetFilters} from 'reducers/filtersVehiclesTrailersSlice';
import { ENDPOINT } from "constants/variables";
import { resetPagination } from 'reducers/paginationVehiclesTrailersSlice';
import Box from '@mui/material/Box'; 
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress'; 
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle'; 
import IconButton from '@mui/material/IconButton';  
import MenuItem  from "@mui/material/MenuItem";  
import SearchIcon from '@mui/icons-material/Search';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import TextField from '@mui/material/TextField'; 
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews";
import { useTranslation } from "react-i18next"    
import "css/generalSettings.css";
import "css/customDialog.css";
import { successErrorAction,warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import TableSortingVehiclesTrailers from "pages/vehiclesTrailers/SortingTablesVehiclesTrailers";
import VehiclesTrailersSearchStores from "pages/vehiclesTrailers/StoresSearchStores";

import PropTypes from 'prop-types'; 

const initialFilters= {
  "idFrom":"",
  "idTo":"",
  "licenseplateFrom":"",
  "licenseplateTo":"",
  "vehicleTrailerStoreFrom":"",
  "vehicleTrailerStoreTo":"",
  "enabled":true,
  "notenabled":true 
}; 

const initialState = [{
  "id" : "",
  "licenseplate" : "",
  "enabled" : true,
  "vehicletrailerstore_store_id" : 0,
  "vehicletrailerstore_store_tradename" : ""
}];

const initialStoresToSelect = [{
  "id": "",
  "documentid": "",
  "tradename": ""
}];

const initialVehicleToSelect = [{
  "id": "",
  "vehicletrailerstore_licenseplate": "" 
}];

const headCells = [
  {
    id: 'vehicletrailerstore_store_tradename',
    numeric: false,
    disablePadding: false,
    label: 'Text_VehicleTrailer_STORE',
    canOrder:true,
  },
  {
    id: 'licenseplate',
    numeric: false,
    disablePadding: false,
    label: 'Text_VehicleTrailer_LICENSEPLATE',
    canOrder:true,
  },
  {
    id: 'enabled',
    numeric: false,
    disablePadding: false,
    label: 'Text_VehicleTrailer_ENABLED',
    canOrder:true,
  }
  
];
 
const VehiclesTrailersSettings = ({setShowPrincipalMenu, showVehiclesTrailersSettings, setShowVehiclesTrailersSettings,setShowModalGeneralSettings}) => {
  const {t } = useTranslation(['listDataGeneralSettings']);
  const token = useSelector((state) => state.loginUser.token); 
  
  const LIMITPAGESIZE = useSelector((state) => state.loginUser.defaultticketsformat.limitpagesize);
const roles = useSelector((state) => state.loginUser.roles);  
  const DELETE_CODE = useSelector((state) => state.formatDIUser.delete_code); 
  const [data, setData] = useState(initialState);
  const [form, setForm] = useState(initialState[0]);
  const filtersVehiclesTrailersDetails = useSelector((state) => state.filtersVehiclesTrailers); 
  const [filtersVehiclesTrailers, setfiltersVehiclesTrailersTrailers] = useState(initialFilters);
  const [numTotReg, setNumTotReg] = useState(0);
  const [numTotRegFilter, setNumTotRegFilter] = useState(0);
  const [errorsFilters, setErrorsFilters] = useState({});
  const [errors, setErrors] = useState({});
  const [inputText, setInputText] = useState("");
  const [openCreateData, setOpenCreateData] = useState(false);
  const [openDeleteRow, setOpenDeleteRow] = useState(false);
  const [openEditRow, setOpenEditRow] = useState(false);
  const [openEditFilter, setOpenEditFilter] = useState(false);
  const [rowEdit, setRowEdit] = useState(initialState[0]);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingError, setIsLoadingError] = useState(false);
  const [idCodeDelete, setIdCodeDelete] = useState(DELETE_CODE);
  const dispatch = useDispatch();
  const [activeOffset, setActiveOffset] = useState(false);
  const [currencyOffset, setCurrencyOffset] = useState(0);
  const [rangeOffset, setRangeOffset] = useState([{}]);   
  const [tradenameToSelect,setTradenameToSelect]= useState(initialStoresToSelect); 
  const [filteredStoreFrom, setFilteredStoreFrom] = useState([]); // Opciones filtradas
  const [highlightedIndexStoreFrom, setHighlightedIndexStoreFrom] = useState(-1); // Índice de la opción resaltada 
  const [filteredStoreTo, setFilteredStoreTo] = useState([]); // Opciones filtradas
  const [highlightedIndexStoreTo, setHighlightedIndexStoreTo] = useState(-1); // Índice de la opción resaltada    
  const [vehiclesToSelect,setVehiclesToSelect]= useState(initialVehicleToSelect); 
  const [filteredVehicleFrom, setFilteredVehicleFrom] = useState([]); // Opciones filtradas
  const [highlightedIndexVehicleFrom, setHighlightedIndexVehicleFrom] = useState(-1); // Índice de la opción resaltada 
  const [filteredVehicleTo, setFilteredVehicleTo] = useState([]); // Opciones filtradas
  const [highlightedIndexVehicleTo, setHighlightedIndexVehicleTo] = useState(-1); // Índice de la opción resaltada 
  const [filteredTradename, setFilteredTradename] = useState([]); // Opciones filtradas
  const [highlightedIndexTradename, setHighlightedIndexTradename] = useState(-1); // Índice de la opción resaltada 
  const [showModalSearchStores, setShowModalSearchStores] = useState(false); 
  
  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showVehiclesTrailersSettings) {
        setData(initialState);
        setForm(initialState[0]);
        setNumTotReg(0);
        setNumTotRegFilter(0);
        setErrorsFilters({});
        setErrors({});
        setInputText("");
        setOpenCreateData(false);
        setOpenDeleteRow(false);
        setOpenEditRow(false);
        setOpenEditFilter(false);
        setRowEdit(initialState[0]); 
        setIsLoadingError(false);
        setIdCodeDelete(DELETE_CODE);
        setActiveOffset(false);
        setCurrencyOffset(0);
        setRangeOffset([{}]);  
        setShowPrincipalMenu(true);
        setShowVehiclesTrailersSettings(false);  
        setTradenameToSelect(initialStoresToSelect);
        setFilteredStoreFrom([]);
        setHighlightedIndexStoreFrom(-1); 
        setFilteredStoreTo([]);  
        setHighlightedIndexStoreTo(-1);  
        setVehiclesToSelect(initialVehicleToSelect);
        setFilteredVehicleFrom([]);
        setHighlightedIndexVehicleFrom(-1);  
        setFilteredVehicleTo([]);
        setHighlightedIndexVehicleTo(-1);  
        setFilteredTradename([]);
        setHighlightedIndexTradename(-1);  
        dispatch(resetPagination());
        dispatch(resetFilters());
        dispatch(setLoading(false));  
        setfiltersVehiclesTrailersTrailers(initialState);  
        setShowModalSearchStores(false); 
        setShowModalGeneralSettings(false);
      }
    },
    [ setData,
      setForm,
      setfiltersVehiclesTrailersTrailers,
      setNumTotReg,
      setNumTotRegFilter,
      setErrorsFilters,
      setErrors,
      setInputText,
      setOpenCreateData,
      setOpenDeleteRow,
      setOpenEditRow,
      setOpenEditFilter,
      setRowEdit,
      setIsLoadingError,
      setIdCodeDelete,
      setActiveOffset,
      setCurrencyOffset,
      setRangeOffset,   
      showVehiclesTrailersSettings, 
      setShowPrincipalMenu,
      setShowVehiclesTrailersSettings,
      setShowModalGeneralSettings,
      setTradenameToSelect,
      setFilteredStoreFrom,
      setHighlightedIndexStoreFrom, 
      setFilteredStoreTo,
      setHighlightedIndexStoreTo, 
      setVehiclesToSelect,
      setFilteredVehicleFrom,
      setHighlightedIndexVehicleFrom, 
      setFilteredVehicleTo,
      setHighlightedIndexVehicleTo, 
      setFilteredTradename,
      setHighlightedIndexTradename, 
      setShowModalSearchStores,
      dispatch,
      DELETE_CODE]
  );

  const closeModalUserTypeSettings = () => {    
    setData(initialState);
      setForm(initialState[0]);
      setNumTotReg(0);
      setNumTotRegFilter(0);
      setErrorsFilters({});
      setErrors({});
      setInputText("");
      setOpenCreateData(false);
      setOpenDeleteRow(false);
      setOpenEditRow(false);
      setOpenEditFilter(false);
      setRowEdit(initialState[0]); 
      setIsLoadingError(false);
      setIdCodeDelete(DELETE_CODE);
      setActiveOffset(false);
      setCurrencyOffset(0);
      setRangeOffset([{}]);  
      setShowPrincipalMenu(true);
      setShowVehiclesTrailersSettings(false);  
      setTradenameToSelect(initialStoresToSelect);
      setFilteredStoreFrom([]);
      setHighlightedIndexStoreFrom(-1); 
      setFilteredStoreTo([]);  
      setHighlightedIndexStoreTo(-1); 
      setVehiclesToSelect(initialVehicleToSelect);
      setFilteredVehicleFrom([]);
      setHighlightedIndexVehicleFrom(-1);  
      setFilteredVehicleTo([]);
      setHighlightedIndexVehicleTo(-1);  
      setFilteredTradename([]);
      setHighlightedIndexTradename(-1);  
      dispatch(resetPagination());
      dispatch(resetFilters());
      dispatch(setLoading(false));
      setfiltersVehiclesTrailersTrailers(initialState); 
      setShowModalSearchStores(false); 
      setShowModalGeneralSettings(false);
  };

  // Debounce helper
  const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    }, [callback, delay]);
  };
  // Dentro del componente
  const debouncedHandleSearchStoreFrom = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredStoreFrom([]);
      setHighlightedIndexStoreFrom(-1);
      return;
    }
    const filtered = tradenameToSelect
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        const documentid = store.documentid.toUpperCase();
        return tradename.includes(upperValue) || documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredStoreFrom(filtered);
    setHighlightedIndexStoreFrom(0);
  }, 300);
  const handleSelectStoreFrom = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setfiltersVehiclesTrailersTrailers(filtersVehiclesTrailers => ({
      ...filtersVehiclesTrailers,
      vehicleTrailerStoreFrom: store.tradename || "",
      vehicleTrailerStoreTo: store.tradename || filtersVehiclesTrailers.vehicleTrailerStoreTo
    }));
    setFilteredStoreFrom([]);
    setHighlightedIndexStoreFrom(-1);
  }; 
  const handleKeyDownStoreFrom = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredStoreFrom.length === 0 && filtersVehiclesTrailers.vehicleTrailerStoreFrom.trim() === "") {
        setFilteredStoreFrom(tradenameToSelect);
        setHighlightedIndexStoreFrom(0);
      } else {
        setHighlightedIndexStoreFrom((prevIndex) => {
          const nextIndex = prevIndex < filteredStoreFrom.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexStoreFrom((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexStoreFrom >= 0) {
      if (highlightedIndexStoreFrom >= 0 && highlightedIndexStoreFrom < filteredStoreFrom.length) {
        handleSelectStoreFrom(filteredStoreFrom[highlightedIndexStoreFrom]);
      }
    } else if (event.key === "Escape") {
      const isValid = tradenameToSelect.some((store) => {
        if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = filtersVehiclesTrailers.vehicleTrailerStoreFrom.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
        setfiltersVehiclesTrailersTrailers(filtersVehiclesTrailers => ({
          ...filtersVehiclesTrailers,
          vehicleTrailerStoreFrom: ""
        }));
      }
      setFilteredStoreFrom([]);
      setHighlightedIndexStoreFrom(-1);
    }
  };
  // Dentro del componente
  const debouncedHandleSearchStoreTo = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredStoreTo([]);
      setHighlightedIndexStoreTo(-1);
      return;
    }
    const filtered = tradenameToSelect
      .filter(store=>(store.tradename>=filtersVehiclesTrailers.vehicleTrailerStoreFrom))
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        const documentid = store.documentid.toUpperCase();
        return tradename.includes(upperValue) || documentid.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
    setFilteredStoreTo(filtered);
    setHighlightedIndexStoreTo(0);
  }, 300);
   const handleSelectStoreTo = (store) => {
     if (!store) return; // Validación adicional para evitar errores
     setfiltersVehiclesTrailersTrailers(filtersVehiclesTrailers => ({
      ...filtersVehiclesTrailers,
      vehicleTrailerStoreTo:  store.tradename || ""
    }));
    setFilteredStoreTo([]);
    setHighlightedIndexStoreTo(-1);
   }; 
   const handleKeyDownStoreTo = (event) => {
     if (event.key === "ArrowDown") {
       if (filteredStoreTo.length === 0 && filtersVehiclesTrailers.vehicleTrailerStoreTo.trim() === "") {
         const filtered = tradenameToSelect.filter(item=>(item.tradename>=filtersVehiclesTrailers.vehicleTrailerStoreFrom));
         setFilteredStoreTo(filtered);
         setHighlightedIndexStoreTo(0);
       } else {
         setHighlightedIndexStoreTo((prevIndex) => {
           const nextIndex = prevIndex < filteredStoreTo.length - 1 ? prevIndex + 1 : prevIndex;
           scrollToElement(nextIndex);
           return nextIndex;
         });
       }
     } else if (event.key === "ArrowUp") {
       setHighlightedIndexStoreTo((prevIndex) => {
         const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
         scrollToElement(prevIndexValid);
         return prevIndexValid;
       });
     } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexStoreTo >= 0) {
       if (highlightedIndexStoreTo >= 0 && highlightedIndexStoreTo < filteredStoreTo.length) {
         handleSelectStoreTo(filteredStoreTo[highlightedIndexStoreTo]);
       }
     } else if (event.key === "Escape") {
       const isValid = tradenameToSelect
       .filter(item=>(item.tradename>=filtersVehiclesTrailers.vehicleTrailerStoreFrom))
       .some((store) => {
        if (!store || !store.tradename) return false; 
          const normalizedTradeName = store.tradename.toUpperCase();
          const normalizedInputTradeName = filtersVehiclesTrailers.vehicleTrailerStoreTo.toUpperCase();
          return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
        setfiltersVehiclesTrailersTrailers(filtersVehiclesTrailers => ({
          ...filtersVehiclesTrailers,
          vehicleTrailerStoreTo:  ""
        }));
      }
      setFilteredStoreTo([]);
      setHighlightedIndexStoreTo(-1);
     }
   };  
  // Dentro del componente
  const debouncedHandleSearchVehicleFrom = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredVehicleFrom([]);
      setHighlightedIndexVehicleFrom(-1);
      return;
    }
    const filtered = vehiclesToSelect
      .filter(vehicle => vehicle && vehicle.vehicletrailerstore_licenseplate)
      .filter(vehicle => {
        const vehicletrailerstore_licenseplate = vehicle.vehicletrailerstore_licenseplate.toUpperCase();
         return vehicletrailerstore_licenseplate.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
      setFilteredVehicleFrom(filtered);
      setHighlightedIndexVehicleFrom(0);
  }, 300);
  const handleSelectVehicleFrom = (vehicle) => {
    if (!vehicle) return; // Validación adicional para evitar errores
    setfiltersVehiclesTrailersTrailers(filtersVehiclesTrailers => ({
      ...filtersVehiclesTrailers,
      licenseplateFrom: vehicle.vehicletrailerstore_licenseplate || "",
      licenseplateTo: vehicle.vehicletrailerstore_licenseplate || filtersVehiclesTrailers.licenseplateTo,
    }));
    setFilteredVehicleFrom([]);
    setHighlightedIndexVehicleFrom(-1);
  }; 
  const handleKeyDownVehicleFrom = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredVehicleFrom.length === 0 && filtersVehiclesTrailers.licenseplateFrom.trim() === "") {
        setFilteredVehicleFrom(vehiclesToSelect);
        setHighlightedIndexVehicleFrom(0);
      } else {
        setHighlightedIndexVehicleFrom((prevIndex) => {
          const nextIndex = prevIndex < filteredVehicleFrom.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexVehicleFrom((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexVehicleFrom >= 0) {
      if (highlightedIndexVehicleFrom >= 0 && highlightedIndexVehicleFrom < filteredVehicleFrom.length) {
        handleSelectVehicleFrom(filteredVehicleFrom[highlightedIndexVehicleFrom]);
      }
    } else if (event.key === "Escape") {
      const isValid = vehiclesToSelect.some((vehicle) => {
        if (!vehicle || !vehicle.vehicletrailerstore_licenseplate) return false; 
        const normalizedVehicle = vehicle.vehicletrailerstore_licenseplate.toUpperCase().replace(/[.-]/g, "");
        const normalizedInputVehicle = filtersVehiclesTrailers.licenseplateFrom.toUpperCase().replace(/[.-]/g, "");
        return normalizedVehicle === normalizedInputVehicle;
      }); 
      if (!isValid) {
        setfiltersVehiclesTrailersTrailers(filtersVehiclesTrailers => ({
          ...filtersVehiclesTrailers,
          licenseplateFrom: ""
        }));
      }
      setFilteredVehicleFrom([]);
      setHighlightedIndexVehicleFrom(-1);
    }
  };
  // Dentro del componente
  const debouncedHandleSearchVehicleTo = useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredVehicleTo([]);
      setHighlightedIndexVehicleTo(-1);
      return;
    }
    const filtered = vehiclesToSelect
      .filter(vehicle=>(vehicle.vehicletrailerstore_licenseplate>=filtersVehiclesTrailers.licenseplateFrom))
      .filter(vehicle => vehicle && vehicle.vehicletrailerstore_licenseplate)
      .filter(vehicle => {
        const vehicletrailerstore_licenseplate = vehicle.vehicletrailerstore_licenseplate.toUpperCase();
        return vehicletrailerstore_licenseplate.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
      setFilteredVehicleTo(filtered);
      setHighlightedIndexVehicleTo(0);
  }, 300);
  const handleSelectVehicleTo = (vehicle) => {
    if (!vehicle) return; // Validación adicional para evitar errores
    setfiltersVehiclesTrailersTrailers(filtersVehiclesTrailers => ({
      ...filtersVehiclesTrailers,
      licenseplateTo: vehicle.vehicletrailerstore_licenseplate || ""
    })); 
    setFilteredVehicleTo([]);
    setHighlightedIndexVehicleTo(-1);
  }; 
  const handleKeyDownVehicleTo = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredVehicleTo.length === 0 && filtersVehiclesTrailers.licenseplateTo.trim() === "") {
        const filtered = vehiclesToSelect.filter(item=>(item.vehicletrailerstore_licenseplate>=filtersVehiclesTrailers.licenseplateFrom));
        setFilteredVehicleTo(filtered);
        setHighlightedIndexVehicleTo(0);
      } else {
        setHighlightedIndexVehicleTo((prevIndex) => {
          const nextIndex = prevIndex < filteredVehicleTo.length - 1 ? prevIndex + 1 : prevIndex;
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexVehicleTo((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexVehicleTo >= 0) {
      if (highlightedIndexVehicleTo >= 0 && highlightedIndexVehicleTo < filteredVehicleTo.length) {
        handleSelectVehicleTo(filteredVehicleTo[highlightedIndexVehicleTo]);
      }
    } else if (event.key === "Escape") {
      const isValid = vehiclesToSelect
      .filter(item=>(item.vehicletrailerstore_licenseplate>=filtersVehiclesTrailers.licenseplateFrom))
      .some((vehicle) => {
        if (!vehicle || !vehicle.vehicletrailerstore_licenseplate) return false; 
        const normalizedVehicle = vehicle.vehicletrailerstore_licenseplate.toUpperCase().replace(/[.-]/g, "");
        const normalizedInputVehicle = filtersVehiclesTrailers.licenseplateTo.toUpperCase().replace(/[.-]/g, "");
        return normalizedVehicle === normalizedInputVehicle;
      }); 
      if (!isValid) {
        setfiltersVehiclesTrailersTrailers(filtersVehiclesTrailers => ({
          ...filtersVehiclesTrailers,
           licenseplateTo: ""
        }));   
      }
      setFilteredVehicleTo([]);
      setHighlightedIndexVehicleTo(-1);
    }
  }; 
  // Dentro del componente
  const debouncedHandleSearchTradename= useDebounce((searchValue) => {
    const upperValue = searchValue.toUpperCase();
    if (upperValue.trim() === "") {
      setFilteredTradename([]);
      setHighlightedIndexTradename(-1);
      return;
    }
    const filtered = tradenameToSelect
      .filter(store => store && store.tradename)
      .filter(store => {
        const tradename = store.tradename.toUpperCase();
        return tradename.includes(upperValue);
      })
      .slice(0, 20); // limitar resultados
      setFilteredTradename(filtered);
      setHighlightedIndexTradename(0);
  }, 300);
  const handleSelectTradeName = (store) => {
    if (!store) return; // Validación adicional para evitar errores
    setForm((form) => ({
      ...form,
      vehicletrailerstore_store_id: store.id || 0,
      vehicletrailerstore_store_tradename: store.tradename || ""
    }));
    setFilteredTradename([]);
    setHighlightedIndexTradename(-1);
  }; 
  const handleKeyDownTradename = (event) => {
    if (event.key === "ArrowDown") {
      if (filteredTradename.length === 0 && form.vehicletrailerstore_store_tradename.trim() === "") {
        setFilteredTradename(tradenameToSelect);
        setHighlightedIndexTradename(0);
      } else {
        setHighlightedIndexTradename((prevIndex) => {
          const nextIndex = prevIndex < filteredTradename.length - 1 ? prevIndex + 1 : prevIndex;
          // Desplaza al siguiente elemento
          scrollToElement(nextIndex);
          return nextIndex;
        });
      }
    } else if (event.key === "ArrowUp") {
      setHighlightedIndexTradename((prevIndex) => {
        const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        // Desplaza al elemento anterior
        scrollToElement(prevIndexValid);
        return prevIndexValid;
      });
    } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexTradename >= 0) {
      if (highlightedIndexTradename >= 0 && highlightedIndexTradename < filteredTradename.length) {
        handleSelectTradeName(filteredTradename[highlightedIndexTradename]);
      }
    } else if (event.key === "Escape") {
      const isValid = tradenameToSelect.some((store) => {
        if (!store || !store.tradename) return false; 
        const normalizedTradeName = store.tradename.toUpperCase();
        const normalizedInputTradeName = form.vehicletrailerstore_store_tradename.toUpperCase();
        return normalizedTradeName === normalizedInputTradeName;
      }); 
      if (!isValid) {
        setForm((form) => ({
          ...form,
          vehicletrailerstore_store_id: 0,
          vehicletrailerstore_store_tradename: "",
        }));
      } 
      setFilteredTradename([]);
      setHighlightedIndexTradename(-1);
    }
  };

   // Función para desplazar el contenedor
  const scrollToElement = (index) => {
    const dropdown = document.querySelector(".dropdown-class"); // Cambia por tu clase/ID
    const item = dropdown?.children[index];
    if (item) {
      item.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  };

  const handleBlur = useCallback((event) => {
    if (!event || !event.currentTarget) return;
    // Asegúrate de que no se cierra si haces clic en un elemento de la lista
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setFilteredStoreFrom([]);
      setHighlightedIndexStoreFrom(-1); 
      setFilteredStoreTo([]);
      setHighlightedIndexStoreTo(-1);  
      setFilteredVehicleFrom([]);
      setHighlightedIndexVehicleFrom(-1);
      setFilteredVehicleTo([]);
      setHighlightedIndexVehicleTo(-1);
      setFilteredTradename([]);
      setHighlightedIndexTradename(-1); 
    }
  }, []);

  const openCreateOrEditData = () => {
    setInputText("");
    setOpenCreateData(true);
  };

  const openEditFilters = () => {
    setOpenEditFilter(!openEditFilter);
  };

  const handleSubmitFilterEdit = () => {
    setErrorsFilters(validateFormFilter()); 
    if (Object.keys(errorsFilters).length === 0) {
      setErrorsFilters({});
      dispatch(resetPagination());
      dispatch(setFilters(filtersVehiclesTrailers));
      setOpenEditFilter(false);
    }  else{
      dispatch(warningErrorAction(t('Text_Error_Filter')));
    }
  }
  
  const handleDeleteFilters = () => {
    setErrorsFilters({});
    dispatch(resetFilters());
    dispatch(resetPagination());
    setfiltersVehiclesTrailersTrailers(initialFilters); 
    setOpenEditFilter(!openEditFilter);
  };

  const handleCancelFilters = () => {
    setErrorsFilters({});
    setOpenEditFilter(!openEditFilter);
  };

  const handleChangeEnabledFilter = (e) => {
    setfiltersVehiclesTrailersTrailers(filtersVehiclesTrailers => ({
      ...filtersVehiclesTrailers,
      enabled: !filtersVehiclesTrailers.enabled
    }));
  };

  const handleChangeNotEnabledFilter = (e) => {
    setfiltersVehiclesTrailersTrailers(filtersVehiclesTrailers => ({
      ...filtersVehiclesTrailers,
      notenabled: !filtersVehiclesTrailers.notenabled
    }));
  };

  const toggleDrawerFilterEdit = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault();
      setErrorsFilters({});
      setfiltersVehiclesTrailersTrailers(initialFilters);
      setOpenEditFilter(!openEditFilter);
    }
  };

  const validateFormFilter = () => {
    let errorsFilters = {};
    let regexNumber = /^[0-9]+$/;
     let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (filtersVehiclesTrailers.idFrom!=="" & !regexNumber.test(filtersVehiclesTrailers.idFrom)) {
      errorsFilters.idFrom = 'Text_TextNoNumber';
    }
    if (filtersVehiclesTrailers.idTo!=="" & !regexNumber.test(filtersVehiclesTrailers.idTo)) {
      errorsFilters.idTo = 'Text_TextNoNumber';
    }
    if (filtersVehiclesTrailers.idFrom!=="" & !errorsFilters.idFrom!==undefined){
      if (filtersVehiclesTrailers.idTo!=="" & !errorsFilters.idTo!==undefined){
        if (parseInt(filtersVehiclesTrailers.idTo)<parseInt(filtersVehiclesTrailers.idFrom)){
          errorsFilters.idTo = 'Text_TextGreater_Id';
        }
      }
    }
 
    if (regexInvalidCharacters.test(filtersVehiclesTrailers.licenseplateFrom)) {
      errorsFilters.licenseplateFrom = 'Text_TextNoValid';
    } 
    if (regexInvalidCharacters.test(filtersVehiclesTrailers.licenseplateTo)) {
      errorsFilters.licenseplateTo = 'Text_TextNoValid';
    } 

    if (filtersVehiclesTrailers.licenseplateTo!=="" & filtersVehiclesTrailers.licenseplateTo<filtersVehiclesTrailers.licenseplateFrom){
      errorsFilters.licenseplateTo = 'Text_TextGreater_LicensePlate';
    }
    return errorsFilters;
  }  

  const filteredData = data.filter((el) => {
    if (inputText === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.id || '') +
        String(el.licenseplate || '') +
        String(el.vehicletrailerstore_store_tradename || '');
      let result = dataTranslate.toLowerCase().includes(inputText.toLowerCase());
      return result;
    }
  })

  let inputHandler = (e) => {
    var lowerCase = e.target.value.toLowerCase();
    setInputText(lowerCase);
  };

  const handleChangeDeleteRow = (e) => {
    const value  = e.target.value;
    setIdCodeDelete(value);
  };

  const handleCancelDeleteRow = () => {
    setErrors({});
    setRowEdit(initialState[0]);
    setForm(initialState[0]);
    dispatch(setLoading(false)); 
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRow(false);
  };

  const handleCloseDeleteRow = (e) => {
    if (idCodeDelete !== DELETE_CODE) {
      dispatch(warningErrorAction(t('Text_InvalidCode')));
      return;
    }
    if (e.key !== 'Escape') {
      if (rowEdit.id !== '') {
        const fetchData = async () => {
          dispatch(setLoading(true));
          try {
            const getData = await helpHttp().del(ENDPOINT, `vehiclestrailers/vehiclestrailers`, token, rowEdit);
            if (getData.status === "OK") {
              dispatch(successErrorAction(t('Text_ValidCode')));
              dispatch(successErrorAction(t('Text_DeleteField')));
            } else {
              dispatch(warningErrorAction(t(getData.cause)));
            }
            dispatch(setLoading(false));
          } catch (error) {
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }  
        };
        fetchData();
      } else {
        dispatch(warningErrorAction(t('Text_InvalidId')));
      }
    } 
    setIdCodeDelete(DELETE_CODE);
    setOpenDeleteRow(false);
    handleCloseDataEdit();
  };

  const handleSubmitDataEdit = () => {
    setErrors(validateForm());
    const errorsToCheck = validateForm();
  
    if (Object.keys(errorsToCheck).length === 0 && form.licenseplate !== '' && form.vehicletrailerstore_store_id !==undefined && form.vehicletrailerstore_store_id !== '' && form.vehicletrailerstore_store_id !== '0') {
      const fetchData = async () => {
        dispatch(setLoading(true));
        try {
          const getData = openEditRow
            ? await helpHttp().put(ENDPOINT, `vehiclestrailers/updatevehiclestrailers`, token, form)
            : await helpHttp().post(ENDPOINT, `vehiclestrailers/savevehiclestrailers`, token, form);
          if (getData.status === "OK") {
            dispatch(successErrorAction(t('Text_SaveData')));
            dispatch(setLoading(false));
            handleCloseDataEdit();
          } else {
            dispatch(setLoading(false));
            dispatch(warningErrorAction(t(getData.cause)));
          }
        } catch (error) { 
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t('Text_IncorrectData')));  
        } 
      };
      fetchData();
    } else {
      if (errorsToCheck.licenseplate) {
        dispatch(warningErrorAction(t(errorsToCheck.licenseplate)));
      }else{
        if (errorsToCheck.vehicletrailerstore_store_id) {
          dispatch(warningErrorAction(t(errorsToCheck.vehicletrailerstore_store_id)));
        } else{
          dispatch(warningErrorAction(t('Text_IncorrectData')));
        }    
        
      }
    }
  };

  const handleCloseDataEdit = () => {
    setOpenCreateData(false);
    setOpenEditRow(false);
    setRowEdit(openEditRow?rowEdit:initialState[0]);
    setForm(initialState[0]);
    setErrors({});
    dispatch(setLoading(false));
    setIsLoadingError(false);
    toggleDrawerDataEdit(false);
	};

  const handleBlurDataEdit = (e) => {
    handleChangeDataEdit(e);
    setErrors(validateForm());
  };
  
  const handleChangeDataEdit = (e) => {
    const { name, value } = e.target;
    setForm(form => ({
      ...form,
      [name]: value
    }));
  };

  const handleChangeEnabledVehicle = () => {
    setForm(form => ({
      ...form,
      enabled: !form.enabled
    }));
  };

  const deleteStore = (event) => {
    setForm(form => ({
      ...form,
      vehicletrailerstore_store_id:0,
      vehicletrailerstore_store_tradename:""
    }));
    setErrors(validateForm());
  };

  const searchSTORE= (event) => { 
    setShowModalSearchStores(true);
  };

  const toggleDrawerDataEdit = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    if (event.type === 'keydown') {
      event.preventDefault()
      handleCloseDataEdit();
    }
  };

   const validateForm = () => {
    let errors = {};
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;
    
    if (!form.vehicletrailerstore_store_id || form.vehicletrailerstore_store_id==="" || form.vehicletrailerstore_store_id==="0" || form.vehicletrailerstore_store_id===0) {
      errors.vehicletrailerstore_store_id = 'Text_FieldStoreRequired';
    } 
    if (!form.licenseplate || form.licenseplate==="") {
      errors.licenseplate = 'Text_FieldLicensePlateRequired';
    } else {
      if (regexInvalidCharacters.test(form.licenseplate)) {
        errors.licenseplate = 'Text_TextNoValid';
      } else{
        if (openEditRow){
          if (data.find((key=>(key.licenseplate.toLowerCase()===form.licenseplate.toLowerCase() && key.id!==rowEdit.id)))) {
            errors.licenseplate = 'Text_VehicleTrailer_LicensePlateExist';
          }
        } else {
          if (data.find((key=>key.licenseplate.toLowerCase()===form.licenseplate.toLowerCase()))) {
            errors.licenseplate = 'Text_VehicleTrailer_LicensePlateExist';
          }
        }  
      }   
    }
    return errors;
  };
 
  useEffect(() => {
    setForm(openEditRow?rowEdit:initialState[0]);
  },[rowEdit,openEditRow]);

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    if (numTotRegFilter > LIMITPAGESIZE) {
      setActiveOffset(true);
      const newRangeOffset = [
        {
          value: 0,
          label: " 1 - " + Number(LIMITPAGESIZE).toLocaleString('de-DE'),
        }
      ];
      for (let i = Number(LIMITPAGESIZE); i < numTotRegFilter; i += Number(LIMITPAGESIZE)) {
        newRangeOffset.push({
          value: i,
          label: " " + (i + 1).toLocaleString('de-DE') + " - " + (i + Number(LIMITPAGESIZE)).toLocaleString('de-DE'),
        });
      }
      setRangeOffset(newRangeOffset);
    } else {
      setCurrencyOffset(0);
      setActiveOffset(false);
      setRangeOffset([{}]);
    }
  }, [numTotRegFilter, LIMITPAGESIZE]);
 
  useEffect(() => {
    let isMounted = true; 
    const fetchDataVehicles = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT,`vehiclestrailers/getlisvehiclestrailers`,token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setVehiclesToSelect(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };  
    const fetchDataTradename = async () => {
      try {
        const getData = await helpHttp().get(ENDPOINT,`vehiclestrailers/storesorderbyname`,token);
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) { 
          setTradenameToSelect(getData); 
        }
      } catch (error) { 
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };   

    if (showVehiclesTrailersSettings ) {  
      fetchDataTradename(); 
      fetchDataVehicles();
    }
    return () => { isMounted = false };

  }, [t,token,dispatch,roles,filtersVehiclesTrailers,openEditFilter,showVehiclesTrailersSettings]);
 
  useEffect(() => {
    let ignore = false;
  
    const fetchnumTotReg = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().get(ENDPOINT, `vehiclestrailers/getinformationtablevehiclestrailers`, token);
        if (getData.err || getData.message === "Load failed") {
          setData(initialState);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (!ignore) {
          setNumTotReg(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }  
    };
  
    const fetchnumTotRegFilter = async () => {
      dispatch(setLoading(true));
      try {
        const getData = await helpHttp().post(ENDPOINT, `vehiclestrailers/getcountfiltervehiclestrailers`, token, filtersVehiclesTrailersDetails);
        if (getData.err || getData.message === "Load failed") {
          setData(initialState);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (!ignore) {
          setNumTotRegFilter(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
  
    const fetchData = async () => {
     dispatch(setLoading(true));
      try {
        const getData = await helpHttp().get3(ENDPOINT, `vehiclestrailers/getvehiclestrailers`, token, currencyOffset, LIMITPAGESIZE, filtersVehiclesTrailersDetails);
        if (getData.err || getData.message === "Load failed") {
          setData(initialState);
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
        } else if (!ignore) {
          setData(getData);
          dispatch(setLoading(false));
        }
      } catch (error) {
        dispatch(setLoading(false));
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
  
    if (showVehiclesTrailersSettings) {
      fetchnumTotReg();
      fetchnumTotRegFilter();
      fetchData();
      return () => { ignore = true; };
    }
  }, [ t, token, dispatch, LIMITPAGESIZE, openCreateData, openDeleteRow, openEditRow, rowEdit, showVehiclesTrailersSettings, filtersVehiclesTrailersDetails, currencyOffset]);
  
  return (
    <>
      {showVehiclesTrailersSettings && ( 
        <div className="container-fluid formdi-pending-page">
          <div id="myDIV" className="formdi-pending-header">
            <h1 className="formdi-pending-title">
              {isLoadingError?<i className="fas fa-solid fa-exclamation fa-2x text-danger"></i>:isLoadingData?<CircularProgress color={openDeleteRow?"warning":"primary"}/>:<i className="fas fa-solid fa-truck text-warning"></i>} {t('Text_VehicleTrailer_Config')}
            </h1> {isLoadingData ?
              <CircularProgress sx={{ color : "#f6c23e"}}/>:
                <>
                <div className="formdi-pending-header-actions"> 
                  {roles[0].listmenus.find((key)=>(key.name==='Handle_Store_Add_Trailers'))? (
                    <div>
                      <button type="button"  className="formdi-pending-btn formdi-pending-btn--primary"  onClick={openCreateOrEditData} >
                        {t('Button_Create')}
                      </button>
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary"  onClick={closeModalUserTypeSettings} >
                        {t('Button_Back')}
                      </button>
                    </div>
                  ) : (
                    <div>
                      <button type="button" className="formdi-pending-btn formdi-pending-btn--secondary" onClick={closeModalUserTypeSettings} >
                        {t('Button_Back')}
                      </button>
                    </div>
                  )} 
                </div> 
              </>
            }
          </div>  
          <br/>  
           {/* Buscador */}
          <div className="formdi-pending-search">
            <TextField
              id="outlined-basic"
              variant="outlined"
              value={inputText}
              inputProps={{ style: {fontSize: '18px'} }}
              InputLabelProps={{ style: {fontSize: '18px', background: '#f8f9fc'}}} 
              placeholder={t('Text_VehicleTrailer_Search')}
              onChange={inputHandler}
              fullWidth
              label={t('Text_VehicleTrailer_Search')}>
            </TextField>
          </div> 
          <br/>
          <div id="myNewDIV" className="formdi-pending-filters">
            <h1 className="formdi-pending-filter-title">{t("Text_Filter")}</h1>
            <div className="formdi-pending-filters-row">
              <button type="button" className={`formdi-pending-chip ${filtersVehiclesTrailersDetails.vehicleTrailerStoreFrom !== "" || filtersVehiclesTrailersDetails.vehicleTrailerStoreTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                <span className={`formdi-pending-dot ${ filtersVehiclesTrailersDetails.vehicleTrailerStoreFrom !== "" || filtersVehiclesTrailersDetails.vehicleTrailerStoreTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_VehicleTrailer_STORE")}
              </button>
              <button type="button" className={`formdi-pending-chip ${filtersVehiclesTrailersDetails.licenseplateFrom !== "" || filtersVehiclesTrailersDetails.licenseplateTo !== "" ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                <span className={`formdi-pending-dot ${ filtersVehiclesTrailersDetails.licenseplateFrom !== "" || filtersVehiclesTrailersDetails.licenseplateTo !== ""? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_VehicleTrailer_LICENSEPLATE")}
              </button>  
              <button type="button" className={`formdi-pending-chip ${filtersVehiclesTrailersDetails.enabled ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                <span className={`formdi-pending-dot ${ filtersVehiclesTrailersDetails.enabled? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_VehicleTrailer_ENABLED")}
              </button> 
              <button type="button" className={`formdi-pending-chip ${filtersVehiclesTrailersDetails.notenabled ? "formdi-pending-chip--active": "" }`}  onClick={openEditFilters} >
                <span className={`formdi-pending-dot ${ filtersVehiclesTrailersDetails.notenabled? "formdi-pending-dot--on": ""}`}/>
                  {t("Text_VehicleTrailer_NOTENABLED")}
              </button>  
            </div>
          </div>
          <br/> 
          {!isLoadingData ?
            <>
              <div className="formdi-pending-card-flat">
                <div className="formdi-pending-card-content">
                  <TableSortingVehiclesTrailers
                    data={filteredData}
                    headCells={headCells}
                    numTotRegFilter={numTotRegFilter}
                    titleTable={t('Text_VehicleTrailer_Table')}
                    setOpenDeleteRow={setOpenDeleteRow}
                    setOpenEditRow={setOpenEditRow}
                    setRowEdit={setRowEdit}
                    showEditButton={roles[0].listmenus.find((key)=>(key.name==='Handle_Store_Modify_Trailers'))?true:false}
                    showDeleteButton={roles[0].listmenus.find((key)=>(key.name==='Handle_Store_Delete_Trailers'))?true:false}
                    numTotReg={numTotReg}
                    activeOffset={activeOffset}
                    rangeOffset={rangeOffset}
                    currencyOffset={currencyOffset}
                    setCurrencyOffset={setCurrencyOffset}  
                  >
                  </TableSortingVehiclesTrailers> 
                </div>             
              </div>
              {openEditFilter &&
                <div>
                  <SwipeableDrawer
                    anchor='right'
                    open={true}
                    onClose={toggleDrawerFilterEdit(false)}
                    onOpen={toggleDrawerFilterEdit(true)}>
                    <Container >
                      <Box sx={{ bgcolor: '#ffffff', width: '850' }}>
                        <br/>
                        <div id="myDIV">
                          <h1 className="h1NewStyle px-4 mb-2">{t('Text_Filter')}</h1>
                        </div>
                        <hr className="sidebar-divider d-none d-md-block"/>
                        <form className="createfiltersVehiclesTrailersdelivery" onSubmit={handleCancelFilters}>  
                          <div className="form-floating mb-3 px-4 primary">
                            <div className="form-group">
                              {/* Campo de texto para escribir y filtrar */}
                              <span style={{ position: "relative" }} >
                                <TextField
                                  id="vehicleTrailerStoreFrom"
                                  name="vehicleTrailerStoreFrom"
                                  value={filtersVehiclesTrailers.vehicleTrailerStoreFrom}
                                  onChange={(e) => {
                                    setfiltersVehiclesTrailersTrailers(prev => ({
                                      ...prev,
                                      vehicleTrailerStoreFrom: e.target.value.toUpperCase(),
                                      vehicleTrailerStoreTo: e.target.value.toUpperCase()
                                    }));
                                    debouncedHandleSearchStoreFrom(e.target.value);
                                  }}
                                  onKeyDown={handleKeyDownStoreFrom}
                                  onBlur={(event) => {
                                    if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                      handleBlur();
                                    }
                                  }}
                                  label={errorsFilters.vehicleTrailerStoreFrom!=null?t(errorsFilters.vehicleTrailerStoreFrom):t('Text_Filter_Store_From')}
                                  placeholder={t('Placeholder_Filter_Store_From')}
                                  inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                  variant="outlined" 
                                /> 
                                {/* Desplegable dinámico */}
                                {filteredStoreFrom.length > 0 && (
                                  <div
                                    className="dropdown-class"
                                    style={{
                                      position: "absolute",
                                      left:'0px',
                                      border: "2px solid #4e73df", // Borde azul (#4e73df)
                                      borderRadius: "4px",
                                      marginTop: "4px",
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                      width: "100%",
                                      fontSize: '18px',
                                      backgroundColor: "#f8f9fa", // Fondo gris claro
                                      zIndex: 1000,
                                    }}
                                    onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                  >
                                  {filteredStoreFrom.map((store, index) => (
                                      <MenuItem
                                          key={store.id}
                                          onClick={() => handleSelectStoreFrom(store)}
                                          style={{
                                              cursor: "pointer",
                                              padding: "8px",
                                              borderBottom: "1px solid #eee",
                                              fontSize: '18px',
                                              backgroundColor:
                                              index === highlightedIndexStoreFrom ? "#4e73df" : "transparent",
                                              color: index === highlightedIndexStoreFrom ? "white" : "black",
                                          }}
                                      >
                                        {store.tradename} - {store.documentid}
                                      </MenuItem>
                                    ))}
                                  </div>
                                )}
                                </span>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                <span style={{ position: "relative" }} >
                                  <TextField
                                    id="vehicleTrailerStoreTo"
                                    name="vehicleTrailerStoreTo"
                                    value={filtersVehiclesTrailers.vehicleTrailerStoreTo}
                                    onChange={(e) => {
                                      setfiltersVehiclesTrailersTrailers(prev => ({
                                        ...prev,
                                        vehicleTrailerStoreTo: e.target.value.toUpperCase()
                                      }));
                                      debouncedHandleSearchStoreTo(e.target.value);
                                    }}
                                    onKeyDown={handleKeyDownStoreTo}
                                    onBlur={(event) => {
                                      if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                        handleBlur();
                                      }
                                    }}
                                    label={errorsFilters.vehicleTrailerStoreTo!=null?t(errorsFilters.vehicleTrailerStoreTo):t('Text_Filter_Store_To')}
                                    placeholder={t('Placeholder_Filter_Store_To')}
                                    variant="outlined"
                                    inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                  />
                                  {/* Desplegable dinámico */}
                                  {filteredStoreTo.length > 0 && ( 
                                      <div
                                      className="dropdown-class"
                                      style={{
                                        position: "absolute",
                                        left:'0px',
                                        border: "2px solid #4e73df", // Borde azul (#4e73df)
                                        borderRadius: "4px",
                                        marginTop: "4px",
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        width: "100%",
                                        fontSize: '18px',
                                        backgroundColor: "#f8f9fa", // Fondo gris claro
                                        zIndex: 1000,
                                      }}
                                      onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                    >
                                      {filteredStoreTo.map((store, index) => (
                                        <MenuItem
                                          key={store.id}
                                            onClick={() => handleSelectStoreTo(store)}
                                            style={{
                                                cursor: "pointer",
                                                padding: "8px",
                                                borderBottom: "1px solid #eee",
                                                fontSize: '18px',
                                                backgroundColor:
                                                index === highlightedIndexStoreTo ? "#4e73df" : "transparent",
                                                color: index === highlightedIndexStoreTo ? "white" : "black",
                                            }}
                                          >
                                            {store.tradename} - {store.documentid}
                                          </MenuItem>
                                      ))}
                                    </div>
                                  )}    
                                </span>
                              </div> 

                              <div className="form-group">
                              {/* Campo de texto para escribir y filtrar */}
                              <span style={{ position: "relative" }}>
                                <TextField
                                  id="licenseplateFrom"
                                  name="licenseplateFrom"
                                  value={filtersVehiclesTrailers.licenseplateFrom}
                                  onChange={(e) => {
                                    setfiltersVehiclesTrailersTrailers(prev => ({
                                      ...prev,
                                      licenseplateFrom: e.target.value.toUpperCase(),
                                      licenseplateTo: e.target.value.toUpperCase()
                                    }));
                                    debouncedHandleSearchVehicleFrom(e.target.value);
                                  }}
                                  onKeyDown={handleKeyDownVehicleFrom}
                                  onBlur={(event) => {
                                    if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                      handleBlur();
                                    }
                                  }}
                                  label={errorsFilters.licenseplateFrom!=null?t(errorsFilters.licenseplateFrom):t('Text_Filter_LicensePlate_From')}
                                  placeholder={t('Placeholder_Filter_LicensePlate_From')}
                                  inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                  variant="outlined"
                                />
                                {/* Desplegable dinámico */}
                                {filteredVehicleFrom.length > 0 && (
                                  <div
                                    className="dropdown-class"
                                    style={{
                                      position: "absolute",
                                      left:'0px',
                                      border: "2px solid #4e73df", // Borde azul (#4e73df)
                                      borderRadius: "4px",
                                      marginTop: "4px",
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                      width: "100%",
                                      fontSize: '18px',
                                      backgroundColor: "#f8f9fa", // Fondo gris claro
                                      zIndex: 1000,
                                    }}
                                    onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                  >
                                    {filteredVehicleFrom.map((vehicle, index) => (
                                      <MenuItem
                                          key={vehicle.id}
                                          onClick={() => handleSelectVehicleFrom(vehicle)}
                                          style={{
                                              cursor: "pointer",
                                              padding: "8px",
                                              borderBottom: "1px solid #eee",
                                              fontSize: '18px',
                                              backgroundColor:
                                              index === highlightedIndexVehicleFrom ? "#4e73df" : "transparent",
                                              color: index === highlightedIndexVehicleFrom ? "white" : "black",
                                          }}
                                      >
                                        {vehicle.vehicletrailerstore_licenseplate}
                                      </MenuItem>
                                    ))}
                                  </div>
                                )}
                                </span>  
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
                                <span style={{ position: "relative" }}>
                                  <TextField
                                    id="licenseplateTo"
                                    name="licenseplateTo"
                                    value={filtersVehiclesTrailers.licenseplateTo}
                                    onChange={(e) => {
                                      setfiltersVehiclesTrailersTrailers(prev => ({
                                        ...prev,
                                        licenseplateTo: e.target.value.toUpperCase()
                                      }));
                                      debouncedHandleSearchVehicleTo(e.target.value);
                                    }}
                                    onKeyDown={handleKeyDownVehicleTo}
                                    onBlur={(event) => {
                                      if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                        handleBlur();
                                      }
                                    }}
                                    label={errorsFilters.licenseplateTo!=null?t(errorsFilters.licenseplateTo):t('Text_Filter_LicensePlate_To')}
                                    placeholder={t('Placeholder_Filter_LicensePlate_To')}
                                    inputProps={{ style: {width: 400,  fontSize: '18px', }, maxLength: 100 }}
                                    InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                    variant="outlined"
                                  />   
                                  {/* Desplegable dinámico */}
                                  {filteredVehicleTo.length > 0 && (
                                  <div
                                    className="dropdown-class"
                                    style={{
                                      position: "absolute",
                                      left:'0px',
                                      border: "2px solid #4e73df", // Borde azul (#4e73df)
                                      borderRadius: "4px",
                                      marginTop: "4px",
                                      maxHeight: "200px",
                                      overflowY: "auto",
                                      width: "100%",
                                      fontSize: '18px',
                                      backgroundColor: "#f8f9fa", // Fondo gris claro
                                      zIndex: 1000,
                                    }}
                                    onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                  >
                                    {filteredVehicleTo.map((vehicle, index) => (
                                      <MenuItem
                                        key={vehicle.id}
                                          onClick={() => handleSelectVehicleTo(vehicle)}
                                          style={{
                                              cursor: "pointer",
                                              padding: "8px",
                                              borderBottom: "1px solid #eee",
                                              fontSize: '18px',
                                              backgroundColor:
                                              index === highlightedIndexVehicleTo ? "#4e73df" : "transparent",
                                              color: index === highlightedIndexVehicleTo ? "white" : "black",
                                          }}
                                        >
                                          {vehicle.vehicletrailerstore_licenseplate}
                                        </MenuItem>
                                    ))}
                                  </div>
                                )}    
                              </span>  
                            </div>  

                            <div className="form-group">
                              <Checkbox
                                id="enabled" 
                                name="enabled" 
                                checked={filtersVehiclesTrailers.enabled}
                                onChange={handleChangeEnabledFilter}
                                variant="standard"
                                sx={{
                                  '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                }}
                              />
                              &nbsp;&nbsp;    
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Vehicle_ENABLED')}</label>  
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                              <Checkbox
                                id="notenabled" 
                                name="notenabled" 
                                checked={filtersVehiclesTrailers.notenabled}
                                onChange={handleChangeNotEnabledFilter}
                                variant="standard"
                                sx={{
                                  '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                }}
                              />
                              &nbsp;&nbsp;    
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Vehicle_NOTENABLED')}</label>    
                            </div>
                          </div>
                          <hr className="sidebar-divider d-none d-md-block" />
                          <div className="formdi-pending-action-group">
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitFilterEdit}>
                              {t('Button_Apply')}
                            </button> 
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleDeleteFilters}>
                              {t('Button_Cancel_Filters')}
                            </button>
                          </div> 
                        </form>
                      </Box>
                    </Container>
                  </SwipeableDrawer>
                </div>
              }  
              
              {(openCreateData || openEditRow) && 
                <div>
                  <SwipeableDrawer
                    anchor='right'
                    open={true}
                    onClose={toggleDrawerDataEdit(false)}
                    onOpen={toggleDrawerDataEdit(true)}>
                    <Container >
                      <Box sx={{ bgcolor: '#ffffff',width: '500px' }}>
                        <br/>
                        <div id="myDIV">
                          <h1 className="h1NewStyle px-4 mb-2">{openEditRow?t('Text_VehicleTrailer_Edit'):t('Text_VehicleTrailer_Create')}</h1>
                        </div>  
                        <hr className="sidebar-divider d-none d-md-block"/>
                        <form className="createVehicles" onSubmit={handleSubmitDataEdit}>  
                          <div className="form-floating mb-3 px-4 primary">
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_Code').toUpperCase()} :</label>
                            <div className="form-group">
                              <TextField
                                id="id" 
                                name="id"
                                value={form.id}
                                disabled
                                inputProps={{ style: {width: 250,fontSize: '18px', }, maxLength: 15 }}
                                style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={t('PlaceHolder_VehiclesTrailer_Code')}
                                placeholder={t('PlaceHolder_VehiclesTrailer_Code')}
                                variant="standard"/>
                            </div>
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_VehicleTrailer_licenseplate').toUpperCase()} :</label>
                            <div className="form-group">
                              <TextField
                                id="licenseplate" 
                                name="licenseplate"
                                value={form.licenseplate}
                                inputProps={{ style: {width: 450,fontSize: '18px', }, maxLength: 50 }}
                                style={{ color:"#4e73df", fontSize: 18, textAlign:'right'}} 
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                                label={errors.licenseplate!=null?t(errors.licenseplate):t('PlaceHolder_VehicleTrailer_licenseplate').toUpperCase()}
                                placeholder={t('PlaceHolder_VehicleTrailer_licenseplate')}
                                variant="standard"
                                onBlur={handleBlurDataEdit}
                                onChange={handleChangeDataEdit} 
                              />
                            </div>
                            <div className="form-group">
                              <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_VehicleTrailer_enabled').toUpperCase()} :</label>
                              <Checkbox  
                                style={{color:"#4e73df"}} 
                                checked={form.enabled} 
                                onChange={handleChangeEnabledVehicle} 
                                sx={{
                                  '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
                                }}
                              />
                            </div>
                            <h6 className="h7NewStyle mb-2">{t('Text_Vehicle_STORE').toUpperCase()}&nbsp;:&nbsp;&nbsp; &nbsp;&nbsp;
                              <IconButton  size="small"  className="deletesmall-select-button"  onClick={deleteStore}>
                                <DeleteIcon style={{fontSize: 28}}/>
                              </IconButton>    
                              &nbsp;&nbsp;
                              <IconButton  size="small"  className="edit-select-button"  onClick={searchSTORE}>
                                <SearchIcon style={{fontSize: 28}}/>
                              </IconButton> 
                            </h6>
                            {/* Divider */}
                            <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_User_Stores').toUpperCase()} :</label>
                            <div className="form-group"style={{ position: "relative" }} >
                               <TextField
                                id="vehicletrailerstore_store_tradename"
                                name="vehicletrailerstore_store_tradename"
                                value={form.vehicletrailerstore_store_tradename}
                                onChange={(e) => {
                                  setForm(prev => ({
                                    ...prev,
                                    vehicletrailerstore_store_tradename: e.target.value.toUpperCase()
                                  }));
                                  debouncedHandleSearchTradename(e.target.value);
                                }}
                                onKeyDown={handleKeyDownTradename}
                                onBlur={(event) => {
                                  if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    handleBlur();
                                  }
                                }}
                                label={errors.vehicletrailerstore_store_tradename!=null?t(errors.vehicletrailerstore_store_tradename):t('Text_User_Stores')}
                                placeholder={t('Text_User_Select_Stores')}
                                variant="standard"
                                inputProps={{ style: {width: 450,  fontSize: '18px', }, maxLength: 100 }}
                                InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                              /> 
                              {/* Desplegable dinámico */}
                              {filteredTradename.length > 0 && (
                                <div
                                  className="dropdown-class"
                                  style={{
                                    position: "absolute",
                                    left:'0px',
                                    border: "2px solid #4e73df", // Borde azul (#4e73df)
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa", // Fondo gris claro
                                    zIndex: 1000,
                                  }}
                                  onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                                >
                                  {filteredTradename.map((store, index) => (
                                    <MenuItem
                                        key={store.id}
                                        onClick={() => handleSelectTradeName(store)}
                                        style={{
                                            cursor: "pointer",
                                            padding: "8px",
                                            borderBottom: "1px solid #eee",
                                            fontSize: '18px',
                                            backgroundColor:
                                            index === highlightedIndexTradename ? "#4e73df" : "transparent",
                                            color: index === highlightedIndexTradename ? "white" : "black",
                                        }}
                                    >
                                      {store.tradename} - {store.documentid}
                                    </MenuItem>
                                  ))}
                                </div>
                              )}
                            </div>
                          </div>  
                          <hr className="sidebar-divider d-none d-md-block" />
                          <div className="formdi-pending-action-group">
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--primary" type="button"  onClick={handleSubmitDataEdit}>
                              {openEditRow?t('Button_Update'):t('Button_Create')}
                            </button> 
                            <button className="formdi-pending-action-btn formdi-pending-action-btn--secondary" type="button" onClick={handleCloseDataEdit}>
                              {t('Button_Cancel')}
                            </button>
                          </div> 
                        </form>
                       
                      </Box> 
                    </Container>
                  </SwipeableDrawer> 
                </div>  
              }
              {/* End Content Row */}
              <VehiclesTrailersSearchStores
                showModalSearchStores={showModalSearchStores}
                setShowModalSearchStores={setShowModalSearchStores} 
                setForm={setForm} 
              /> 
             
            </>:
              <LoadingNews/>
          }
           
          <Dialog open={openDeleteRow} onClose={handleCancelDeleteRow} PaperProps={{ className: "my-dialog-paper-danger" }} >
            <DialogTitle className="my-dialog-title-danger">
              {t('Text_Delete')} {rowEdit.id}  - {rowEdit.licenseplate}
            </DialogTitle>
              <DialogContent>
                <DialogContentText className="my-dialog-contentText-danger">
                  {t("Text_Line1")}<br />
                  {t("Text_Line2")}
                </DialogContentText>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="idCode"
                    label={t("Text_Label")}
                    type="text"
                    fullWidth
                    variant="standard"
                    className="my-dialog-input-danger"
                    defaultValue={idCodeDelete}
                    onChange={handleChangeDeleteRow}
                  />
                </DialogContent>
              <DialogActions className="my-dialog-actions">
              <Button
                onClick={handleCancelDeleteRow}
                className="my-dialog-button-cancel-danger"
              >
                {t("Button_Cancel")}
              </Button>
              <Button
                variant="contained"
                onClick={handleCloseDeleteRow}
                className="my-dialog-button-delete"
              >
                {t("Button_Delete")}
              </Button>
            </DialogActions>
          </Dialog>   
          {/* End Content Row */}
        </div>
        //* End Page Content *//
      )}
    </>
  )
}

VehiclesTrailersSettings.propTypes = {
  setShowPrincipalMenu: PropTypes.func.isRequired,
  showVehiclesTrailersSettings: PropTypes.bool.isRequired,
  setShowVehiclesTrailersSettings: PropTypes.func.isRequired,
  setShowModalGeneralSettings: PropTypes.func.isRequired 
};

export default VehiclesTrailersSettings;